document.addEventListener('DOMContentLoaded', function(){
  document.documentElement.classList.add('maisonamor-loaded');
});

document.addEventListener('click', function(event){
  const thumb = event.target.closest('.ma-thumb-pro');
  if(!thumb) return;
  const url = thumb.getAttribute('data-image');
  const main = document.querySelector('.ma-main-product-image-pro img');
  if(url && main){ main.src = url; main.srcset = ''; }
});
/* MaisonAmor Newsletter Popup */
(function(){
  function initMaisonAmorPopup(){
    var popup = document.getElementById('maNewsletterPopup');
    var overlay = document.getElementById('maPopupOverlay');
    var close = document.getElementById('maPopupClose');

    if(!popup || !overlay || !close) return;

    var hasSeen = localStorage.getItem('maisonamor_popup_seen');

    if(!hasSeen){
      setTimeout(function(){
        popup.classList.add('is-active');
        overlay.classList.add('is-active');
      }, 3500);
    }

    function closePopup(){
      popup.classList.remove('is-active');
      overlay.classList.remove('is-active');
      localStorage.setItem('maisonamor_popup_seen', 'true');
    }

    close.addEventListener('click', closePopup);
    overlay.addEventListener('click', closePopup);
  }

  document.addEventListener('DOMContentLoaded', initMaisonAmorPopup);
})();